import { AppSvg, FormattedCurrency, FormattedHTMLMessage, icons, useNotification } from '@web/walter-ui-kit'
import React, { useEffect } from 'react'
import { GetThreeDSChallengesReturn } from '@web/walter-lib/api/types/cards/returnTypes'
import { NotificationOrToast } from '@web/walter-lib/notifications'
import { lang } from './lang'
import { useCards, useGetThreeDSChallengesData } from '~api/swr/rest'
import { useCardDetailsStore } from '~store/cardDetails'
import { processChallenge } from '~utils/processChallenge'

export const useChallenges = () => {
    const { data: chs } = useGetThreeDSChallengesData()
    const { data: cards } = useCards()
    const { push } = useNotification()

    const { setData } = useCardDetailsStore()

    // eslint-disable-next-line complexity
    useEffect(() => {
        if (chs && cards) {
            const oldChallengesStr = localStorage.getItem('challenges')
            let oldChallenges: GetThreeDSChallengesReturn['challenges'] = []

            if (oldChallengesStr) {
                oldChallenges = JSON.parse(oldChallengesStr)
            }

            if (chs?.challenges && chs?.challenges?.length > 0) {
                chs?.challenges?.forEach(challenge => {
                    const oldCh = oldChallenges?.find(oldChallenge => oldChallenge.id === challenge.id)

                    if (oldCh) {
                        return
                    }

                    const card = cards?.cards?.find(card => card.id === challenge.card_id)

                    if (!card) {
                        return
                    }

                    const notification: NotificationOrToast = {
                        intent: 'notification',
                        icon: <AppSvg svgName={icons.ic18RoundArrowClock} />,
                        title: <FormattedHTMLMessage {...lang.title} />,
                        createdAt: Date.now(),
                        content: (
                            <div className="flex gap-2">
                                <FormattedCurrency
                                    maxPrecision={2}
                                    minimumFractionDigits={2}
                                    value={`-${challenge.amount}`}
                                    currency={challenge?.currency}
                                    dataPointer="amount"
                                    isSignAlwaysDisplay
                                />
                                <FormattedHTMLMessage {...lang.fromCard} values={{ numbers: card?.masked_number }} />
                            </div>
                        ),
                        buttonProps: {
                            text: <FormattedHTMLMessage {...lang.view} />,
                            fullWidth: true,
                            onClick: () => setData({ isOpen: true, tx: processChallenge(challenge) }),
                        },
                        status: 'warning',
                        dataPointer: 'approve_notification',
                    }

                    notification && push(notification)
                })
            }

            localStorage.setItem('challenges', JSON.stringify(chs?.challenges || []))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chs, cards])
}
